module.exports = __webpack_public_path__ + "img/different.b161f495.jpg";